import { Button, Modal } from '@dev-spendesk/grapes';
import { useEffect, useState } from 'react';

import { useTranslation } from 'common/hooks/useTranslation';
import { type UserTask } from 'modules/onboarding/setup-hub/types/userTask';
import { type HubTask } from 'modules/onboarding/types/hubTask';
import { LocalStorageKey } from 'src/core/constants/storage';

type Props = {
  allTasks: (UserTask | HubTask)[];
};

export const AllSetupHubTasksCompletedModal = ({ allTasks }: Props) => {
  const { t } = useTranslation('global');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasBeenShown, setHasBeenShown] = useState(
    !!localStorage.getItem(LocalStorageKey.SetupHubCompletionModalShown),
  );

  useEffect(() => {
    // Only show modal if tasks are completed AND it hasn't been shown before
    if (allTasks.length > 0 && !hasBeenShown) {
      const areAllTasksCompleted = allTasks.every(
        (task) => task.status === 'completed',
      );
      if (areAllTasksCompleted) {
        setIsModalOpen(true);
        // Mark as shown immediately to prevent re-triggering
        localStorage.setItem(
          LocalStorageKey.SetupHubCompletionModalShown,
          'true',
        );
        setHasBeenShown(true);
      }
    }
  }, [hasBeenShown, allTasks]);

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      title={t('setupHub.completionModal.title')}
      subtitle={t('setupHub.completionModal.description')}
      iconName="circle-check"
      iconVariant="success"
      actions={[
        <Button
          key="done"
          variant="primarySuccess"
          text={t('misc.done')}
          onClick={() => setIsModalOpen(false)}
        />,
      ]}
    />
  );
};
